/* FG 03.11.2026 Menü v3 (fgnav) – Neubau von fg-menu.js (Menü v2).
   Regeln (claude/menue-konzept-v3.md): kein globales Objekt, Abfragen nur innerhalb der Menü-Wurzeln
   (Desktop: nav[data-fgnav-root="desktop"], mobil: [data-fgnav-m]), Listener an den Wurzeln statt an document.
   Funktionen wie v2: Bereichswechsel Desktop, Ebenen/Reiter mobil, sofortiger Tipp + Rückmeldung (R13),
   Ladeleiste, Sale-Restzeit, Konfigurator-Animation (nur Menü). */
(function () {
  'use strict';
  function $$(s, c) { return Array.prototype.slice.call(c.querySelectorAll(s)); }
  var desk = document.querySelector('nav[data-fgnav-root="desktop"]');
  var mobs = Array.prototype.slice.call(document.querySelectorAll('[data-fgnav-m]'));
  if (!desk && !mobs.length) return;

  /* ---------- Ladeleiste beim Seitenwechsel ---------- */
  function bar() {
    var b = document.getElementById('fgnav-bar');
    if (!b) { b = document.createElement('div'); b.id = 'fgnav-bar'; document.body.appendChild(b); }
    b.className = ''; void b.offsetWidth; b.className = 'fgnav-on';
  }
  function navigates(a, e) {
    if (!a || a.tagName !== 'A' || a.hasAttribute('data-fgnav-m-go')) return false;
    if (e && (e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button > 0)) return false;
    if (a.target && a.target !== '_self') return false;
    var h = a.getAttribute('href') || '';
    if (!h || h.charAt(0) === '#' || /^(javascript|mailto|tel):/i.test(h)) return false;
    return true;
  }
  window.addEventListener('pageshow', function () {
    var b = document.getElementById('fgnav-bar'); if (b) b.className = '';
    [desk].concat(mobs).forEach(function (r) { if (r) $$('.fgnav-go,.fgnav-press', r).forEach(function (x) { x.classList.remove('fgnav-go', 'fgnav-press'); }); });
  });

  /* ---------- Desktop: Bereiche per Hover/Fokus umschalten ---------- */
  if (desk) {
    var railTimer = null;
    var railSwitch = function (item) {
      var wrap = item.closest('[data-fgnav-rail]'); if (!wrap) return;
      var key = item.getAttribute('data-fgnav-area');
      $$('[data-fgnav-area]', wrap).forEach(function (a) { a.classList.toggle('fgnav-on', a === item); });
      $$('[data-fgnav-panel]', wrap).forEach(function (p) { p.classList.toggle('fgnav-on', p.getAttribute('data-fgnav-panel') === key); });
    };
    desk.addEventListener('mouseover', function (e) {
      var it = e.target.closest && e.target.closest('[data-fgnav-area]'); if (!it || !desk.contains(it)) return;
      clearTimeout(railTimer); railTimer = setTimeout(function () { railSwitch(it); }, 80);
    });
    desk.addEventListener('focusin', function (e) {
      var it = e.target.closest && e.target.closest('[data-fgnav-area]'); if (it && desk.contains(it)) railSwitch(it);
    });
    desk.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href]');
      if (a && desk.contains(a) && navigates(a, e)) { a.classList.add('fgnav-go'); bar(); }
    });
  }

  /* ---------- Mobil: Ebenen, Zurück, Reiter ---------- */
  function show(root, id) {
    var target = root.querySelector('[data-fgnav-m-panel="' + id + '"]'); if (!target) return false;
    $$('[data-fgnav-m-panel]', root).forEach(function (p) { p.hidden = p !== target; p.classList.toggle('fgnav-on', p === target); });
    var sc = root.closest('[data-scrollable]'); if (sc) sc.scrollTop = 0;
    return true;
  }
  function act(root, el, e) {
    var go = el.closest('[data-fgnav-m-go]');
    if (go && root.contains(go)) { if (show(root, go.getAttribute('data-fgnav-m-go')) && e) e.preventDefault(); return true; }
    var back = el.closest('[data-fgnav-m-back]');
    if (back && root.contains(back)) { show(root, back.getAttribute('data-fgnav-m-back')); if (e) e.preventDefault(); return true; }
    var tab = el.closest('[data-fgnav-m-tab]');
    if (tab && root.contains(tab)) {
      var panel = tab.closest('[data-fgnav-m-panel]'); if (!panel) return true;
      var key = tab.getAttribute('data-fgnav-m-tab');
      $$('[data-fgnav-m-tab]', panel).forEach(function (b) { b.classList.toggle('fgnav-on', b === tab); b.setAttribute('aria-selected', b === tab ? 'true' : 'false'); });
      $$('[data-fgnav-m-tabpanel]', panel).forEach(function (t) { var on = t.getAttribute('data-fgnav-m-tabpanel') === key; t.hidden = !on; t.classList.toggle('fgnav-on', on); });
      return true;
    }
    return false;
  }
  var SEL = 'a[href], [data-fgnav-m-back], [data-fgnav-m-tab]';
  mobs.forEach(function (root) {
    root.addEventListener('click', function (e) {
      if (act(root, e.target, e)) return;
      var a = e.target.closest && e.target.closest('a[href]');
      if (a && root.contains(a) && navigates(a, e)) { a.classList.add('fgnav-go'); bar(); }
    });
    /* R13: Tipp (< 10 px, < 600 ms) sofort auslösen – auf dem iPhone ging der erste Tipp teils verloren */
    var sx = 0, sy = 0, st = 0, tEl = null, moved = false;
    root.addEventListener('touchstart', function (e) {
      var el = e.target.closest && e.target.closest(SEL);
      tEl = (el && root.contains(el) && e.touches.length === 1) ? el : null; moved = false;
      if (!tEl) return;
      sx = e.touches[0].clientX; sy = e.touches[0].clientY; st = Date.now();
      tEl.classList.add('fgnav-press');
    }, { passive: true });
    root.addEventListener('touchmove', function (e) {
      if (!tEl) return;
      var t = e.touches[0];
      if (Math.abs(t.clientX - sx) > 10 || Math.abs(t.clientY - sy) > 10) { moved = true; tEl.classList.remove('fgnav-press'); }
    }, { passive: true });
    root.addEventListener('touchcancel', function () { if (tEl) tEl.classList.remove('fgnav-press'); tEl = null; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      var el = tEl; tEl = null; if (!el) return;
      setTimeout(function () { el.classList.remove('fgnav-press'); }, 180);
      if (moved || Date.now() - st > 600) return;
      if (el.tagName === 'A' && navigates(el)) {
        e.preventDefault(); el.classList.add('fgnav-go'); bar(); location.href = el.href;
      } else if (act(root, el, null)) {
        e.preventDefault();
      }
    }, { passive: false });
  });
  /* Beim Öffnen des Seitenmenüs immer auf der Startebene beginnen (nur der Prestige-Auslöser des Menü-Drawers) */
  Array.prototype.slice.call(document.querySelectorAll('[data-action="open-drawer"][data-drawer-id="sidebar-menu"]')).forEach(function (o) {
    o.addEventListener('click', function () { mobs.forEach(function (r) { show(r, 'root'); }); });
  });

  /* ---------- Mobil: Aktions-Leiste mit Restzeit ---------- */
  function z(n) { return (n < 10 ? '0' : '') + n; }
  var ends = [];
  mobs.forEach(function (r) { ends = ends.concat($$('[data-fgnav-m-end]', r)); });
  function tick() {
    ends.forEach(function (el) {
      var raw = (el.getAttribute('data-fgnav-m-end') || '').replace(/([+-]\d{2})(\d{2})$/, '$1:$2');
      var end = Date.parse(raw), s = Math.floor((end - Date.now()) / 1000), cd = el.querySelector('[data-fgnav-m-cd]');
      if (isNaN(end) || s <= 0) { el.classList.remove('fgnav-live'); if (cd) cd.textContent = 'Jetzt ansehen ›'; return; }
      var d = Math.floor(s / 86400), h = Math.floor(s % 86400 / 3600), m = Math.floor(s % 3600 / 60);
      el.classList.add('fgnav-live');
      if (cd) cd.textContent = 'endet in ' + (d ? d + ' T ' : '') + z(h) + ':' + z(m);
    });
  }
  if (ends.length) { tick(); setInterval(tick, 30000); }

  /* ---------- Konfigurator-Animation (nur im Menü, eigene Attribute data-fgnav-k) ---------- */
  function fgk(el) {
    var plants = $$('.fgnav-k__plant', el), pots = $$('.fgnav-k__pot', el);
    if (plants.length < 2 || pots.length < 2) return;
    var pi = 0, ti = 0, step = 0, timer = null;
    function on(list, i) { list.forEach(function (x, k) { x.classList.toggle('fgnav-on', k === i); }); }
    function next() {
      step++;
      if (step % 3 === 0) { pi = (pi + 1) % plants.length; on(plants, pi); }
      else { ti = (ti + 1) % pots.length; on(pots, ti); }
    }
    function run(go) { clearInterval(timer); timer = go ? setInterval(next, 1700) : null; }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { es.forEach(function (x) { run(x.isIntersecting); }); }).observe(el);
    } else { run(true); }
  }
  if (!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) {
    [desk].concat(mobs).forEach(function (r) { if (r) $$('[data-fgnav-k]', r).forEach(fgk); });
  }
})();
